<template>
	<div class="step-5" data-config-step="5">
		<general-modal />
		<pos-mode-modal />
		<rules-modal-step5 />
		<loading v-if="loading || showLoadingOverlay">
			{{ loadingText }}
		</loading>
		<template v-if="!loading">
			<checkout-heading
				:build-price="buildPrice"
				:country-code="countryCode"
				:draft-id="draftId"
				@checkout="startProcessCheckout"
				@go-back="gotoStep4()"
				@showContingencyModal="$modal.show('contingency-modal')"
			/>
			<div class="container">
				<div class="row">
					<div class="col-md-3">
						<games-fps
							:resolution-text="resolutionText"
							:selected-games="games"
						/>
						<hr>
						<build-includes class="hidden-xs" :active-build="activeBuild" />
					</div>
					<div class="col-md-9">
						<step-5-specs
							ref="specs"
							:active-build="activeBuild"
							:session-data="sessionData"
							:build-price="buildPrice"
							@checkout="startProcessCheckout"
							@fix-this="fixThis"
							@showContingencyModal="$modal.show('contingency-modal')"
						/>
					</div>
					<build-includes class="visible-xs-block col-xs-12" :active-build="activeBuild" />
					<build-note class="visible-xs-block visible-sm-block" />
				</div>
			</div>
			<contingency-modal />
		</template>
	</div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import { checkoutMixins, heapAnalytics } from "@u/mixins";
import { isMobile } from "@u/helpers";
import ConfiguratorMixin from "@m/configurator";
import CheckoutHeading from "./checkout-heading";
import GamesFps from "./games-fps";
import BuildIncludes from "./build-includes";
import Step5Specs from "./step-5-specs";
import BuildNote from "./build-note";
import PosModeModal from "../pos-mode-modal";
import RulesModalStep5 from "./rules-modal-step5";
import ContingencyModal from "./contingency-modal";
import { gtmTrack, gtmSaveCartTotal } from "@/util/gtm";

export default {
	name: "Step5",
	components: {
		BuildIncludes,
		BuildNote,
		CheckoutHeading,
		GamesFps,
		Step5Specs,
		PosModeModal,
		RulesModalStep5,
		ContingencyModal
	},
	mixins: [
		checkoutMixins,
		ConfiguratorMixin,
		heapAnalytics
	],
	data() {
		return {
			loading: true,
			step4MenuLevels: {
				configure: ["case", "cooling", "motherboard", "gpu", "cpu", "psu", "ram", "storage"],
				rgbs: ["rgbs", "extras", "peripherals", "monitor", "color", "software", "services"]
			}
		};
	},
	computed: {
		...mapGetters([
			"resolutionText"
		]),
		...mapState({
			activeBuild: state => state.Step4.activeBuild,
			buildPrice: state => state.Step4.buildPrice,
			countryCode: state => state.User.location.country_code,
			draftId: state => state.Step4.draftId,
			games: state => state.Step4.sessionGamesData,
			loadingText: state => state.Step4.loadingText,
			sessionData: state => state.Step4.sessionData,
			showLoadingOverlay: state => state.Step4.showLoadingOverlay
		})
	},
	watch: {
		buildPrice: {
			handler(price) {
				if (price) {
					gtmSaveCartTotal(price);
					gtmTrack.cartTotal(price);
				}
			},
			immediate: true
		}
	},
	beforeRouteEnter(to, from, next) {
		gtmTrack.cartPrebuild();
		gtmTrack.cartTotalByRoute(to, from);
		next();
	},
	created() {
		this.setupStep4MenuLevels();
	},
	mounted() {
		$(".row.header-dp").css({
			opacity: "1"
		});
	},
	methods: {
		...mapActions([
			"changeActiveMenu",
			"changeActiveTab",
			"changeActiveSubtab",
			"changeLoadingText",
			"changeShowLoadingOverlay",
			"setFromStep5"
		]),
		async fixThis(tab, subtab) {
			await this.changeActiveMenu(this.step4MenuLevels[tab]);
			await this.changeActiveTab(tab);
			await this.changeActiveSubtab(subtab);
			await this.setFromStep5(true);

			this.gotoStep4();
		},
		gotoStep4() {
			const step = "step4" + (isMobile() && "-mobile" || "");

			this.$router.push({
				name: step,
				query: {
					price: this.$route.query.price,
					draft: this.$route.query.draft
				}
			});
		},
		hideLoading() {
			this.loading = false;
		},
		setupStep4MenuLevels() {
			const menuLevels = {};

			Object.keys(this.step4MenuLevels).forEach(level => {
				this.step4MenuLevels[level].forEach(menu => {
					menuLevels[menu] = level;
				});
			});

			this.step4MenuLevels = menuLevels;
		},
		showErrorModal(message) {
			this.$modal.show("general", {
				title: "Error",
				content: message
			});
		},
		showLoading() {
			this.loading = true;
		},
		startProcessCheckout(location) {
			if (!this.POS_MODE) {
				this.processCheckout(this.draftId, "step5", location);
			} else {
				this.$modal.show("pos-mode");
			}
		}
	}
};
</script>

<style lang="scss" scoped>
@import '~@s/_asset-mixers.scss';

.step-5 {
    padding-bottom: 50px;
    background-color: #1A1A1A;
    overflow-x: hidden;

    @media (min-width: 768px) and (max-width: 991px) {
        padding-bottom: 0;
    }

    @media (max-width: 767px) {
        padding-bottom: 100px;
    }

    .container {
        @media (min-width: 1315px) {
            width: 1310px;
        }

        @media (min-width: 1200px) and (max-width: 1315px) {
            width: 1150px;
        }

        @media (min-width: 768px) and (max-width: 991px) {
            padding: 0 70px 40px;
        }

        .row {
            @media (max-width: 768px) {
                margin-top: 110px;
                padding: 0 15px;
            }
        }
    }

    .col-md-3 {
        padding: 0;
        padding-right: 5px;
    }

    hr {
        margin: 0;
        border-top-color: $white;
        opacity: 0.4;
    }
}

.zd-widget-move-step5-holiday {
	.step-5 {
		@media (max-width: 767px) {
			padding-bottom: 180px;
		}
	}
}
</style>
